export default {
  forEmployer: '採用企業様',
  language: '言語'
}
